<template>
    <ContentComponentItem
        v-for="(component, key) in data"
        :key="key"
        :background="background"
        :has-eager-image="hasEagerImage"
        :data="component"
    />
</template>

<script setup lang="ts">
import type { Color, ContentComponentItemFragment } from '@/graphql/api'
import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'

defineProps<{
    data?: ContentComponentItemFragment[]
    background?: Color
    hasEagerImage?: boolean
}>()
</script>
